import { brazeConstants } from '../constants/brazeConstants'
import { brazeService } from '../../services/API/brazeService'

export const addBraze = (postData, url) => {
  //alert('ddd')
  return dispatch => {
    brazeService.addBraze(postData, url).then(
      data => {
      
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function success(data) {
    console.log(data);
    return { type: brazeConstants.BRAZE_SUCCESS, data }
  }
  function failure(error) {
    return { type: brazeConstants.BRAZE_FAILURE, error }
  }
}

export const editBraze = (postData, url) => {
  return dispatch => {
    brazeService.editBraze(postData, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function success(data) {
    return { type: brazeConstants.BRAZE_SUCCESS, data }
  }
  function failure(error) {
    return { type: brazeConstants.BRAZE_FAILURE, error }
  }
}

export const getBrazeDetail = (id, url) => {
  return dispatch => {
    brazeService.getBrazeDetail(id, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function success(data) {
    return { type: brazeConstants.GET_BRAZE_SUCCESS, data }
  }
  function failure(error) {
    return { type: brazeConstants.GET_BRAZE_FAILURE, error }
  }
}

export const listBraze = (postData, url) => {
  return dispatch => {
    brazeService.listBraze(postData, url).then(
      data => {
        dispatch(success(data))
      },
      error => {
        dispatch(failure(error.toString()))
      }
    )
  }
  function success(data) {
    return { type: brazeConstants.LIST_BRAZE_SUCCESS, data }
  }
  function failure(error) {
    return { type: brazeConstants.LIST_BRAZE_FAILURE, error }
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/actions/brazeActions.js